<div class="d-flex flex-column">
  <div class="d-flex flex-wrap">
     <div class="fs-10 fw-2 text-neutral-dark">du {{ moment(startDate).locale('fr').format('LL') }}</div>
     @if (endDate) {
     <div class="fs-10 fw-2 text-neutral-dark">au {{ moment(endDate).format('LL') }}</div>
     } @else {
     <div class="fs-10 fw-2 text-neutral-dark">— durée indéterminée</div>
     }
  </div>
  <!--<span class="text-neutral-dark-grey fs-11 fw-400">{{days}} jours</span>!-->
</div>
